import { render, staticRenderFns } from "./Criar-Enquete.vue?vue&type=template&id=3c69eadf&"
import script from "./Criar-Enquete.vue?vue&type=script&lang=js&"
export * from "./Criar-Enquete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Criar-Enquete.vue"
export default component.exports